import { useEffect } from 'react'
import { useAuth } from '@/context/AuthContext'

const KEY = 'admin_impersonation_email'

export function AdminImpersonationBanner() {
	const { user } = useAuth()
	const adminEmail = typeof window !== 'undefined' ? localStorage.getItem(KEY) : null
	const isVisible = !!adminEmail && !!user?.email && user.email.toLowerCase() !== adminEmail.toLowerCase()

	useEffect(() => {
		if (typeof document === 'undefined') return
		document.documentElement.style.setProperty(
			'--admin-impersonation-banner-height',
			isVisible ? '42px' : '0px'
		)
		return () => {
			document.documentElement.style.setProperty('--admin-impersonation-banner-height', '0px')
		}
	}, [isVisible])

	if (!isVisible) {
		return null
	}

	const stopImpersonation = async () => {
		const { getAuthHeaders } = await import('@/services/api')
		const { getApiBaseUrl } = await import('@/lib/api')
		const headers = await getAuthHeaders()
		if (typeof window !== 'undefined') {
			headers['X-App-Origin'] = window.location.origin
		}
		const response = await fetch(`${getApiBaseUrl()}/api/admin/impersonate/stop`, {
			method: 'POST',
			headers,
			body: JSON.stringify({ adminEmail }),
		})
		const payload = await response.json()
		if (!response.ok || !payload.redirectUrl) return
		localStorage.removeItem(KEY)
		window.location.assign(payload.redirectUrl)
	}

	return (
		<div className="w-full border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900">
			<div className="mx-auto flex w-full max-w-[1400px] flex-wrap items-center justify-between gap-2 md:flex-nowrap">
				<span className="font-medium">You are viewing the app as {user.email}</span>
				<button
					type="button"
					onClick={stopImpersonation}
					className="w-full rounded border border-amber-700 bg-amber-200 px-3 py-1 text-xs font-semibold hover:bg-amber-300 md:w-auto"
				>
					Stop impersonation / return to admin
				</button>
			</div>
		</div>
	)
}
